import { Link } from "react-router-dom";
import { WorkspaceCardData } from "./Interfaces/WorkspaceCard";

// Utility function to format numbers with commas
const formatCurrency = (amount: number): string => {
  return amount.toLocaleString();
};

export default function WorkspaceCard(workspace: WorkspaceCardData) {
  return (
    <Link
      to={`/workspace/${workspace.workspaceId}`}
      className="block rounded-2xl overflow-hidden border border-gray-300 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col cursor-pointer"
    >
      <div className="aspect-w-16 aspect-h-9 overflow-hidden">
        <img
          src={workspace.images[0]?.imageUrl}
          alt={workspace.title}
          className="w-full h-48 rounded-2xl object-cover"
        />
      </div>
      <div className="p-4 flex-grow flex flex-col">
        <div className="flex justify-between items-start mb-2">
          <h2 className="text-xl font-semibold line-clamp-2">
            {workspace.title}
          </h2>
          <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded ml-2 flex-shrink-0">
            {workspace.workspaceType}
          </span>
        </div>
        <p className="text-gray-600 mb-3 line-clamp-2">{workspace.address}</p>

        <div className="flex justify-between items-center mt-auto">
          <span className="font-bold text-lg">
            ${formatCurrency(workspace.pricePerYear)}/year
          </span>
          <span className="text-sm text-gray-500">
            Capacity: {formatCurrency(workspace.capacity)}
          </span>
        </div>
      </div>
    </Link>
  );
}
